// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-39234bac] #body-layout {\n  height: 100% !important;\n}\n#main-content[data-v-39234bac]:has(.m-drawings) {\n  min-width: 700px;\n  min-height: 300px;\n  padding: 0px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
